var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 10,
    fill: "#E1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9121 22.1988C19.9121 20.7698 21.0706 19.6113 22.4996 19.6113C23.9286 19.6113 25.0871 20.7698 25.0871 22.1988C25.0871 23.6278 23.9286 24.7863 22.4996 24.7863C21.0706 24.7863 19.9121 23.6278 19.9121 22.1988Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22.2C11 24.0853 11.4887 24.7202 12.4661 25.9901C14.4178 28.5255 17.6908 31.4 22.5 31.4C27.3092 31.4 30.5822 28.5255 32.5339 25.9901C33.5112 24.7202 34 24.0853 34 22.2C34 20.3147 33.5112 19.6798 32.5339 18.41C30.5822 15.8745 27.3092 13 22.5 13C17.6908 13 14.4178 15.8745 12.4661 18.41C11.4887 19.6798 11 20.3147 11 22.2ZM22.5 17.8875C20.1183 17.8875 18.1875 19.8183 18.1875 22.2C18.1875 24.5818 20.1183 26.5125 22.5 26.5125C24.8818 26.5125 26.8125 24.5818 26.8125 22.2C26.8125 19.8183 24.8818 17.8875 22.5 17.8875Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon1);
export default __webpack_public_path__ + "static/media/step_icon_1.eba2bf2bc64786d53230d5abacb47f1a.svg";
export { ForwardRef as ReactComponent };